
const accordionSection = document.querySelectorAll('[id^="accordion--"]')
if (accordionSection) {
    accordionSection.forEach((eachAccordion)=>{
        const fullId = eachAccordion.id;
        const sectionId = fullId.replace('accordion--', '');
        const details = document.querySelectorAll(`.detail--${sectionId}`);
        details.forEach((targetDetail) => {
            targetDetail.addEventListener("click", () => {
                // Close all the details that are not targetDetail.
                details.forEach((detail) => {
                    if (detail !== targetDetail) {
                        detail.removeAttribute("open");
                    }
                });
            });
        });
    })
}